/**
 * tdesign v0.21.1
 * (c) 2022 tdesign
 * @license MIT
 */

import { _ as _defineProperty } from '../_chunks/dep-0b4c3c44.mjs';
import { defineComponent, inject, computed, h, createVNode } from 'vue';
import { i as isFunction_1 } from '../_chunks/dep-0b4185fe.mjs';
import { CheckIcon, CloseIcon } from 'tdesign-icons-vue-next';
import props from './step-item-props.mjs';
import { usePrefixClass } from '../hooks/useConfig.mjs';
import { useGlobalIcon } from '../hooks/useGlobalIcon.mjs';
import '../hooks/index.mjs';
import { useConfig } from '../config-provider/useConfig.mjs';
import { useTNodeJSX, useContent } from '../hooks/tnode.mjs';
import '../_chunks/dep-a48de419.mjs';
import '../_chunks/dep-3ca5fb38.mjs';
import '../_chunks/dep-7071345f.mjs';
import '../_chunks/dep-d2403b2f.mjs';
import '../hooks/icon.mjs';
import '../hooks/slot.mjs';
import '../hooks/useCommonClassName.mjs';
import '../hooks/useDefaultValue.mjs';
import '../_chunks/dep-baa4f9dc.mjs';
import '../_chunks/dep-db11154e.mjs';
import '../_chunks/dep-a82b01df.mjs';
import '../_chunks/dep-192e10f1.mjs';
import '../_chunks/dep-3d4aad09.mjs';
import '../_chunks/dep-977c5cdd.mjs';
import '../_chunks/dep-c27b1c14.mjs';
import '../hooks/useDestroyOnClose.mjs';
import '../hooks/useKeepAnimation.mjs';
import '../_chunks/dep-bfb23a5e.mjs';
import '../_chunks/dep-2a7dc5c7.mjs';
import '../_chunks/dep-9311bf66.mjs';
import '../_chunks/dep-4889eb51.mjs';
import '../_chunks/dep-7922050a.mjs';
import '../_chunks/dep-169ea640.mjs';
import '../_chunks/dep-f6b25712.mjs';
import '../_chunks/dep-59545a4d.mjs';
import '../_chunks/dep-7d96367f.mjs';
import '../_chunks/dep-827c4600.mjs';
import '../_chunks/dep-0820e0e2.mjs';
import '../_chunks/dep-caad2e91.mjs';
import '../_chunks/dep-8e38f523.mjs';
import '../_chunks/dep-469bf54b.mjs';
import '../_chunks/dep-8ef9fb8e.mjs';
import '../_chunks/dep-e769aafd.mjs';
import '../_chunks/dep-400798c5.mjs';
import '../_chunks/dep-361522ee.mjs';
import '../_common/js/global-config/default-config.mjs';
import '../_common/js/global-config/locale/zh_CN.mjs';
import '../hooks/useRipple.mjs';
import '../utils/set-style.mjs';
import '../hooks/useVirtualScroll.mjs';
import '../hooks/useVModel.mjs';
import '../config-provider/type.mjs';
import '../_chunks/dep-40522c7c.mjs';
import '../_chunks/dep-83862ee1.mjs';
import '../_chunks/dep-8e451077.mjs';
import '../_chunks/dep-755716aa.mjs';
import '../_chunks/dep-82798823.mjs';
import '../_chunks/dep-52cbb58a.mjs';
import '../utils/render-tnode.mjs';
import '../_chunks/dep-2684fd15.mjs';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var _StepItem = defineComponent({
  name: "TStepItem",
  props: _objectSpread(_objectSpread({}, props), {}, {
    index: Number
  }),
  setup: function setup(props2) {
    var stepsState = inject("StepsState", void 0);
    var stepsProps = inject("StepsProps", void 0);

    var _useConfig = useConfig("steps"),
        globalConfig = _useConfig.globalConfig;

    var _useGlobalIcon = useGlobalIcon({
      CheckIcon: CheckIcon,
      CloseIcon: CloseIcon
    }),
        CheckIcon$1 = _useGlobalIcon.CheckIcon,
        CloseIcon$1 = _useGlobalIcon.CloseIcon;

    var canClick = computed(function () {
      return props2.status !== "process" && !(stepsProps !== null && stepsProps !== void 0 && stepsProps.readonly);
    });

    var onStepClick = function onStepClick(e) {
      if (!canClick.value) return;
      var val = props2.value === void 0 ? props2.index : props2.value;
      stepsState.setCurrent(val, stepsState.current, {
        e: e
      });
    };

    var COMPONENT_NAME = usePrefixClass("steps-item");
    var statusClass = computed(function () {
      return _defineProperty({}, "".concat(COMPONENT_NAME.value, "--").concat(props2.status), props2.status);
    });
    var baseClass = computed(function () {
      return [COMPONENT_NAME.value, statusClass.value];
    });
    var iconClass = computed(function () {
      return ["".concat(COMPONENT_NAME.value, "__icon"), statusClass.value];
    });
    var renderTNodeJSX = useTNodeJSX();
    var renderContent = useContent();

    var renderIcon = function renderIcon() {
      var defaultIcon;

      if (stepsProps.theme === "default") {
        var icon = "";

        switch (props2.status) {
          case "finish":
            icon = createVNode(CheckIcon$1, null, null);
            break;

          case "error":
            if (isFunction_1(globalConfig.value.errorIcon)) {
              icon = globalConfig.value.errorIcon(h);
            } else {
              icon = createVNode(CloseIcon$1, null, null);
            }

            break;

          default:
            icon = String(props2.index + 1);
            break;
        }

        defaultIcon = createVNode("span", {
          "class": "".concat(COMPONENT_NAME.value, "__icon--number")
        }, [icon]);
      }

      return renderTNodeJSX("icon", defaultIcon);
    };

    return function () {
      return createVNode("div", {
        "class": baseClass.value
      }, [createVNode("div", {
        "class": "".concat(COMPONENT_NAME.value, "__inner ").concat(canClick.value ? "".concat(COMPONENT_NAME.value, "--clickable") : ""),
        "onClick": onStepClick
      }, [createVNode("div", {
        "class": iconClass.value
      }, [renderIcon()]), createVNode("div", {
        "class": "".concat(COMPONENT_NAME.value, "__content")
      }, [createVNode("div", {
        "class": "".concat(COMPONENT_NAME.value, "__title")
      }, [renderTNodeJSX("title")]), createVNode("div", {
        "class": "".concat(COMPONENT_NAME.value, "__description")
      }, [renderContent("default", "content")]), createVNode("div", {
        "class": "".concat(COMPONENT_NAME.value, "__extra")
      }, [renderTNodeJSX("extra")])])])]);
    };
  }
});

export { _StepItem as default };
//# sourceMappingURL=step-item.mjs.map
